import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Style/Accueil.ObsidianAura.css'; // ✅ THEME GLOBAL (variables + overlay styles)
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
